module.exports = require('./helpers/bundle-url').getBundleURL('aWUjo') + "apta_logo_with_text_2022.b6ca17fb.png";